import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {

  constructor(public router:Router) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts